module.exports = __webpack_public_path__ + "img/s2.d36131a5.jpeg";